export default "__VITE_ASSET__Cs_7Vs04__"